import gql from 'graphql-tag';

export const DEFAULT_PAGE_SIZE = 21;

const designerBoardsQuery = gql`
  query DesignerBoards(
    $designerId: ID!
    $pageNumber: Int!,
    $pageSize: Int!,
    $includeHidden: Boolean,
  ) {
    designerPublicBoards(
      designerId: $designerId,
      pageNumber: $pageNumber,
      pageSize: $pageSize,
      includeHidden: $includeHidden,
    ) {
      pageSize
      pageNumber
      itemCount
      items {
        id
        __typename
        productCount: boardProductCount
        publicUrl
        isFeatured
        isHidden
        mainBoardAsset {
          id
          asset {
            id
            url
          }
        }
        boardAssets {
          id,
          asset {
            id
            url
          }
        }
        room {
          id
          roomType {
            id
            type
          }
        }
        subStyles {
          id
          name
        }
      }
    }
  }
`;

export default designerBoardsQuery;

export interface IAsset {
  id: string;
  asset: {
    id: string;
    url: string;
  };
}

export interface IBoardSubStyle {
  id: string;
  name: string;
}

export interface IDesignerBoard {
  id: string;
  typename: string;
  productCount?: number;
  publicUrl?: string;
  isFeatured: boolean;
  isHidden: boolean;
  mainBoardAsset?: IAsset;
  boardAssets: IAsset[];
  room?: {
    id: string;
    roomType?: {
      id: string;
      type: string;
    };
  };
  subStyles: IBoardSubStyle[];
}

export interface IDesignerBoardsData {
  designerPublicBoards: {
    pageSize: number;
    pageNumber: number;
    itemCount: number;
    items: IDesignerBoard[];
  };
}

export interface IDesignerBoardsVariables {
  designerId: string;
  pageNumber: number;
  pageSize: number;
  includeHidden?: boolean;
}
